import { nanoid } from "nanoid";
import { IContentType } from "src/types/settings/formBuilder/IContentType.interface";

export const apiHeaders = (
  headers: Headers,
  { practiceGuid, userSession }: { practiceGuid: string; userSession: string },
  contentType?: IContentType,
  sessionId?: string
): Headers => {
  headers.set("Content-Type", contentType ?? "application/json; charset=utf-8");
  headers.set("X-Yapi-Client-Guid", practiceGuid);
  headers.set("X-Yapi-Client-Profile-Id", "");
  if (userSession) headers.set("Authorization", `Bearer ${userSession}`);
  if (sessionId) {
    headers.set("X-Yapi-WebApp-Instance-Id", sessionId);
  } else {
    headers.set("X-Yapi-WebApp-Instance-Id", `${nanoid(32)}`);
  }
  headers.set("X-Yapi-WebApp-Request-Id", `YDPREQ-${nanoid(32)}`);

  return headers;
};
